'use client';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-white">
      <div className="text-center max-w-3xl w-full p-10 border border-gray-200 shadow-xl rounded-lg">
        {/* Error Code/Icon: A classic approach often includes an error code or icon. 
            We'll use a simple, large text representation for a classic feel. */}
        <p className="text-4xl font-bold text-gray-800 mb-6 font-serif">
          ⊘ {'500'}
        </p>

        {/* Headline: More professional and less aggressive than "Something went wrong!" */}
        <h1 className="text-2xl font-semibold text-gray-800 mb-4">
          Oops! We're experiencing technical difficulties.
        </h1>

        {/* Sub-text: Provide a clear, polite explanation */}
        <p className="text-lg text-gray-600 mb-10 leading-relaxed">
          An unexpected issue has occurred. We recommend you **try refreshing the page**. If the problem persists, please contact support.
        </p>
        <button
          onClick={reset}
          className="button bg-black text-white hover:bg-gray-800 px-8 cursor-pointer"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}